import { getHashTotal } from "lib/saleLot/hashTotal";
import { Big } from "big.js";
import { createLookupCombiner, createLookupSelectors } from "../lib";
import { getSaleLots } from "../root";

export const [selectHashTotalBySaleLotIdLookup, getHashTotalBySaleLotId] =
  createLookupSelectors(
    [getSaleLots],
    createLookupCombiner(getHashTotal),
    Big(0),
  );
